<template>
  <div class="tag-badge">
    <span class="dot text-center pl-1">
      <i :class="i" class="orange-icon" />
    </span>
    <span class="tag-badge-title">{{ title }}</span>
  </div>
</template>
<script>
export default {
  meta: {
    description:
      'Componente insignia que escala con el tamaño relativo de las fuentes, de nombre BadgeModal.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    title: {
      type: String,
      default: '',
      meta: {
        description: 'Encabezado principal del Badge',
        example: 'Texto Necesario',
      },
    },
    i: {
      type: String,
      default: '',
      meta: {
        description: 'Estable el icono del badge con sus clases',
        example: 'Texto Necesario',
      },
    },
  },
};
</script>
<style scoped>
.tag-badge {
  display: inline-block;
  padding: 0rem 1.2rem 0rem 0rem;
  height: 43px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  margin-bottom: 10px;
}

.dot {
  width: 41px;
  height: 41px;
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
}
.orange-icon {
  color: #ff7058;
  font-size: 14pt;
  padding-right: 4px;
  line-height: 23px;
}
.tag-badge-title {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
  padding-left: 1rem !important;
  text-align: left;
  font: Bold 25px/30px Lato;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
}
</style>
